import { Component } from '@angular/core';

@Component({
  selector: 'app-calendar-icon',
  standalone: true,
  host: { class: 'ui-icon' },
  templateUrl: './calendar-icon.component.html',
  styleUrl: '../icon-base.scss'
})
export class CalendarIconComponent {}
